/** @format */

// Start of Selection
/** @format */

import { useState, useEffect } from "react";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Collapse,
  NavbarToggler,
  Container,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faBagShopping } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <div
        style={{
          backgroundColor: "#66b1b1",
          padding: "10px 0",
          borderBottom: "2px solid #5a9e9e",
        }}></div>
      <Container>
        <Navbar
          expand="md"
          className={`py-3 ${scrolled ? "shadow-sm" : ""}`}
          style={{
            transition: "all 0.3s ease-in-out",
            backgroundColor: scrolled ? "white" : "transparent",
          }}>
          <NavbarBrand
            href="/"
            style={{
              fontWeight: "600",
              fontSize: "1.8rem",
              color: "#66b1b1",
              transition: "all 0.3s ease",
            }}>
            <img
              src="https://tealbo.com/tbocore_afiles/2024/11/tealbo-logo-e1732441146380.png"
              alt="Your Brand Logo"
              style={{
                height: "100px",
                width: "auto",
              }}
            />
          </NavbarBrand>
          <NavbarToggler onClick={toggle} />
          <Collapse isOpen={isOpen} navbar>
            <Nav className="mx-auto" navbar style={{ fontSize: "1rem" }}>
              <NavItem>
                <NavLink
                  href="https://tealbo.com/"
                  className="nav-link-hover"
                  style={{
                    color: "black",
                    padding: "0.5rem 1rem",
                    fontWeight: "600",
                  }}>
                  Home
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://cafe.tealbo.com/"
                  className="nav-link-hover"
                  style={{
                    color: "black",
                    padding: "0.5rem 1rem",
                    fontWeight: "600",
                  }}>
                  Gelato Cafe
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://tealbo.com/tealbo-shop/"
                  className="nav-link-hover"
                  style={{
                    color: "black",
                    padding: "0.5rem 1rem",
                    fontWeight: "600",
                  }}>
                  Online Mall
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://tealbo.com/vendor-carts/"
                  className="nav-link-hover"
                  style={{
                    color: "black",
                    padding: "0.5rem 1rem",
                    fontWeight: "600",
                  }}>
                  Cart
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://tealbo.com/checkout/"
                  className="nav-link-hover"
                  style={{
                    color: "black",
                    padding: "0.5rem 1rem",
                    fontWeight: "600",
                  }}>
                  Checkout
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="https://tealbo.com/my-account/"
                  className="nav-link-hover"
                  style={{
                    color: "black",
                    padding: "0.5rem 1rem",
                    fontWeight: "600",
                  }}>
                  My Account
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="/cart"
                  className="position-relative"
                  style={{
                    color: "black",
                    padding: "0.5rem 1rem",
                    fontWeight: "600",
                  }}>
                  <FontAwesomeIcon icon={faBagShopping} />

                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                    style={{
                      backgroundColor: "#66b1b1",
                      fontSize: "0.75rem",
                      padding: "0.2em 0.4em",
                      marginRight: "-10px",
                    }}>
                    0
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="/search"
                  className="nav-link-hover"
                  style={{
                    color: "black",
                    padding: "0.5rem 1rem",
                    fontWeight: "600",
                  }}>
                  <FontAwesomeIcon icon={faSearch} />
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </Container>
    </>
  );
};

export default Header;
